import { DEFAULT_CURRENCY } from 'src/i18n/currencies/constants'

const BASE_CURRENCY = {
  style: 'currency',
  currency: DEFAULT_CURRENCY
}

const BASE_CURRENCY_NO_CENTS = {
  ...BASE_CURRENCY,
  minimumFractionDigits: 0,
  maximumFractionDigits: 0
}

const BASE_CURRENCY_HUNDREDTHS = {
  ...BASE_CURRENCY,
  minimumFractionDigits: 4,
  maximumFractionDigits: 4
}

/**
 * Number formats for VueI18n. On these, the locale fallbacks apparently only apply
 * within the base language (e.g. 'en' or 'es'). Maybe a bug in VueI18n. So we must
 * repeatedly define the 'es' formats as well (done after the object below). All English
 * locales successfully fallback to the 'en' definitions. These must match the options
 * available in the Intl.NumberFormat constructor.
 * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Intl/NumberFormat/NumberFormat#parameters
 */
const numberFormats = {
  en: {
    decimal: {
      style: 'decimal'
    },
    decimal0: {
      style: 'decimal',
      minimumFractionDigits: 0,
      maximumFractionDigits: 0
    },
    decimal1: {
      style: 'decimal',
      minimumFractionDigits: 0,
      maximumFractionDigits: 1
    },
    decimalExactly1: {
      style: 'decimal',
      minimumFractionDigits: 1,
      maximumFractionDigits: 1
    },
    decimal2: {
      style: 'decimal',
      minimumFractionDigits: 0,
      maximumFractionDigits: 2
    },
    decimal4: {
      style: 'decimal',
      minimumFractionDigits: 0,
      maximumFractionDigits: 4
    },
    decimalExactly2: {
      style: 'decimal',
      minimumFractionDigits: 2,
      maximumFractionDigits: 2
    },
    compact: {
      notation: 'compact',
      compactDisplay: 'short',
      minimumFractionDigits: 0,
      maximumFractionDigits: 1
    },
    // These are just fallbacks. The `getCurrencyConfigurationsByFormat()`
    // should be called automatically when the locale to update these
    // for the current circuit.
    currency: {
      ...BASE_CURRENCY
    },
    currencyNoCents: {
      ...BASE_CURRENCY_NO_CENTS
    },
    currencyHundredths: {
      ...BASE_CURRENCY_HUNDREDTHS
    }
  },
  es: {
    decimal: {
      style: 'decimal'
    },
    decimal0: {
      style: 'decimal',
      minimumFractionDigits: 0,
      maximumFractionDigits: 0
    },
    decimal1: {
      style: 'decimal',
      minimumFractionDigits: 0,
      maximumFractionDigits: 1
    },
    decimalExactly1: {
      style: 'decimal',
      minimumFractionDigits: 1,
      maximumFractionDigits: 1
    },
    decimal2: {
      style: 'decimal',
      minimumFractionDigits: 0,
      maximumFractionDigits: 2
    },
    decimalExactly2: {
      style: 'decimal',
      minimumFractionDigits: 2,
      maximumFractionDigits: 2
    },
    decimal4: {
      style: 'decimal',
      minimumFractionDigits: 0,
      maximumFractionDigits: 4
    },
    // These are just fallbacks. The `getCurrencyConfigurationsByFormat()`
    // should be called automatically when the locale to update these
    // for the current circuit.
    currency: {
      ...BASE_CURRENCY
    },
    currencyNoCents: {
      ...BASE_CURRENCY_NO_CENTS
    },
    currencyHundredths: {
      ...BASE_CURRENCY_HUNDREDTHS
    }
  }
}
export default numberFormats
